/**
 * Service: templates
 */
angular.module('acme.common.service.templates', [
  'acme.common.service.calendar',
  'acme.common.service.helpers',
  'acme.common.service.flexpay',
  'acme.common.service.templates.helpers'
])
.service('TemplatesService', ['$filter', '$rootScope', 'CalendarService', 'HelpersService', 'TemplatesHelpersService', 'FlexpayService', function($filter, $rootScope, CalendarService, HelpersService, TemplatesHelpersService, FlexpayService) {

    return {

      // Set via resetModel()
      model: {},

      isLoaded: false,

      tabName: '',
      isTabLoading: false,

      admissionTypes: [
        { label: 'Standard', name: 'standard' },
        { label: 'General Admission', name: 'generalAdmission' }
      ],

      isRepeating: false,

      restrict: {
        members: false
      },

      repeatFrequency: {},

      repeatTypes: TemplatesHelpersService.getRepeatTypes(),
      repeatMonthTypes: TemplatesHelpersService.getRepeatMonthTypes(),
      salesChannels: TemplatesHelpersService.getSalesChannels(),
      createHour: TemplatesHelpersService.createHour,
      createRange: TemplatesHelpersService.createRange,
      hourToDate: TemplatesHelpersService.hourToDate,

      flexpay: FlexpayService,

      init: function(template) {
        if (template) {
          this.setModel(template);
        }else{
          this.resetModel();
        }
      },

      /**
       * @param {boolean} loaded
       */
      setIsLoaded: function (loaded) {
        this.isLoaded = loaded;
      },

      /**
       * @param {'$$parent' | 'details' | 'pricing' | 'schedules' | 'flexpay' | 'addons' | 'exceptions'} tabName
       * @param {boolean} loading
       */
      setIsTabLoading: function (loading, tabName) {
        this.isTabLoading = loading;
        this.tabName = tabName;
      },

      setModel: function(model) {
        this.model = model;
        FlexpayService.init(this.model);
        this.verifyCustomFields();
        this.verifyScheduleRanges();
        $rootScope.$broadcast('TemplatesService::Update');
      },

      getModel: function(savePrep) {
        // Seed ticket details in case it does not exist
        this.getTicketDetails();
        this.getColorCategory();
        if (savePrep) {
          this.verifyCustomFields();
          this.verifySchedules();
        }
        return this.model;
      },

      stripNew: function() {
        if (this.hasSchedules()) {
          this.model.schedules[this.getNewSchedule().index].NEW = null;
          delete this.model.schedules[this.getNewSchedule().index].NEW;
        }
      },

      resetModel: function() {
        this.setModel({
          name: '',
          summary: '',
          description: '',
          shortDescription: '',
          emailConfirmationMessage: '',
          emailCancellationMessage: '',
          admissionType: 'standard',
          reviewState: 'draft',
          GLCode: null,
          rebookingFee: 0,
          ticketDetails: {
            ticketDurationDays: 1,
            expireFromEventDate: true,
            ticketPrintLines: ['', '', '', ''],
            checkInWindow: {
              blockScan: false,
              minutesBefore: 30,
              minutesAfter: 15,
              autoRebook: false
            },
            postStartPurchase: {
              allowLateTicketPurchase: false,
              minutesAfter: 0
            },
            purchaseAvailability: {
              timeFrame: 'when'
            },
            doNotPrint: false
          },
          colorCategory: {
            textColor: '#000000',
            backgroundColor: '#d1d1d1'
          }
        });
      },

      hasSchedules: function() {
        return (this.model.schedules && this.model.schedules instanceof Array && this.model.schedules.length > 0);
      },

      getSchedulesList: function() {
        var schedules = [];

        if (this.hasSchedules()) {
          schedules = this.processSchedules('standard');
        }
        return schedules;

      },

      getPrivateSchedulesList: function() {
        var schedules = [];

        if (this.hasSchedules()) {
          schedules = this.processSchedules('private');
        }
        return schedules;

      },

      removePrivateSchedule: function() {
        var schedules = [];
        for (i=0,ii=this.model.schedules.length;i<ii;i++) {
          if (this.model.schedules[i].type !== 'private') {
            schedules.push(this.model.schedules[i]);
          }
        }
        this.model.schedules = schedules;
      },

      createSchedule: function(scheduleStartTime) {

        var index,
            hour = this.createHour(),
            range = this.createRange(),
            sDate = (scheduleStartTime) ? new Date(scheduleStartTime) : this.hourToDate(hour),
            startTime = sDate.setHours(12),
            endTime = sDate.setHours(13);

        return {
          name: '',
          description : '',
          effectiveStartTime: CalendarService.toISO8601(startTime),
          effectiveEndTime: CalendarService.toISO8601(endTime),
          capacity: 0,
          duration: {
            hour: 1,
            minutes: 0
          },
          repeatCycle: 'never',
          weekdays: [],
          hours: [hour],
          ranges: [range],
          monthly: [],
          daysOfMonth: [],
          days: [CalendarService.toYMDDate(sDate)],
          salesChannels: angular.copy(this.salesChannels),
          orderForms: [],
          type: ''
        };

      },

      processScheduleDuration: function(schedule) {
        var r = '';

        if (schedule.duration) {
          if (schedule.duration.hour > 0) {
            r += schedule.duration.hour + 'hr ';
          }
          if (schedule.duration.minutes > 0) {
            r += schedule.duration.minutes + 'min';
          }
        }

        return r;
      },

      orderSalesChannels: function(salesChannels, restrict) {
        var i, ii,
            channels = [],
            _channels = [],
            order = ['online', 'pointOfSale', 'reseller', 'customerRep', 'manualEntry', 'kiosk'];

        if (salesChannels instanceof Array) {
          for (i=0,ii=salesChannels.length;i<ii;i++) {
            if (order.length && order[0] == salesChannels[i].channel) {
              channels.push(salesChannels[i]);
              order.shift();
            }else{
              _channels.push(salesChannels[i]);
            }
          }

          salesChannels = channels.concat(_channels);
        }

        return salesChannels;
      },

      /**
       * Order price list according to expected values
       *
       * @param priceList {Object}
       * @param restrict {Array}
       * @returns {*}
       */
      processSalesChannels: function(priceList, restrict) {

        var i, ii,
            order;

        if (restrict instanceof Array) {
          order = restrict;
        }

        if (priceList && priceList.prices instanceof Array) {
          for (i=0,ii=priceList.prices.length;i<ii;i++) {
            if (priceList.prices[i].salesChannels instanceof Array) {
              priceList.prices[i].salesChannels = this.orderSalesChannels(priceList.prices[i].salesChannels);
            }
          }
        }


        return (Object.keys(priceList).length) ? priceList : null;

      },

      processSchedules: function(type) {
        var i, ii,
            effectiveDates,
            priceList,
            schedules = [],
            startTime,
            endTime,
            range;

        for (i=0,ii=this.model.schedules.length;i<ii;i++) {

          effectiveDates = TemplatesHelpersService.getEffectiveDates(this.model.schedules[i].effectiveStartTime, this.model.schedules[i].effectiveEndTime);
          range = 0;
          
          if (this.hasSchedulePriceLists(this.model.schedules[i])) {
            priceList = this.model.schedules[i].priceLists[0].name;
          }else if (this.hasPriceLists()) {
            priceList = this.getPriceList().name;
          }else{
            priceList = 'No price list';
          }

          if (this.isAdmissionType('generalAdmission')) {
            startTime = $filter('date')(this.hourToDate(this.model.schedules[i].ranges[0].start), TemplatesHelpersService.getTimeFormat());
            endTime   = $filter('date')(this.hourToDate(this.model.schedules[i].ranges[0].end), TemplatesHelpersService.getTimeFormat());
          } else {
            startTime = $filter('date')(this.hourToDate(this.model.schedules[i].hours[0]), TemplatesHelpersService.getTimeFormat());
            if (this.model.schedules[i].ranges instanceof Array && this.model.schedules[i].ranges.length) {
              endTime = $filter('date')(this.hourToDate(this.model.schedules[i].ranges[0].end), TemplatesHelpersService.getTimeFormat());
            }
          }

          timesCount = this.getTimesCount(this.model.schedules[i]);

          if (this.model.schedules[i].type === type) {
            schedules.push({
              id: this.model.schedules[i].id,
              name: this.model.schedules[i].name,
              capacity: this.model.schedules[i].capacity,
              startTime: startTime,
              endTime: endTime,
              timesCount: timesCount,
              duration: this.processScheduleDuration(this.model.schedules[i]),
              repeatCycle: TemplatesHelpersService.getRepeatType(this.repeatTypes, this.model.schedules[i].repeatCycle).label,
              resourceRequestTypes: TemplatesHelpersService.getResourceRequestTypes(this.model.schedules[i].resourceRequests),
              orderForms: this.model.schedules[i].orderForms,
              salesChannels: this.getSalesChannels(this.model.schedules[i].salesChannels),
              effectiveDates: effectiveDates,
              priceList: priceList
            });
          }
        }

        return schedules;
      },

      getTimesCount: function (model) {
        return {
          general  : this.createTimesCount(model.ranges ? model.ranges.length : 0),
          standard : this.createTimesCount(model.hours ? model.hours.length : 0)
        };
      },

      createTimesCount: function (range) {
        return (range > 1) ? '(' + '+' + (range - 1)  + ')' : '';
      },

      getSalesChannels: function(channels) {
        var i, ii,
            _channels = [];

        for (i=0,ii=channels.length;i<ii;i++) {
          if (channels[i].enabled) {
            _channels.push(channels[i].name);
          }
        }

        return (_channels.length === channels.length) ? 'All' : _channels.join(', ');
      },

      isAdmissionType: function(type) {
        return this.model.admissionType === type;
      },

      createTicketDetails: function() {
        return {
          ticketDurationDays: 1,
          expireFromEventDate: true,
          ticketPrintLines: ['', '', '', ''],
          checkInWindow: {
            blockScan: false,
            minutesBefore: 30,
            minutesAfter: 15,
            autoRebook: false
          },
          postStartPurchase: {
            allowLateTicketPurchase: false,
            minutesAfter: 0
          },
          doNotPrint: false
        };
      },

      getTicketDetails: function() {
        if (!this.model.ticketDetails) {
          this.setTicketDetails(this.createTicketDetails());
        }
        return this.model.ticketDetails;
      },

      setResources: function(resources) {
        this.model.resources = resources;
      },

      getResources: function() {
        if (!this.model.resources) {
          this.model.resources = [];
        }
        return this.model.resources;
      },

      setTicketDetails: function(details) {
        this.model.ticketDetails = details;
      },

      getReviewState: function() {
        return this.model.reviewState;
      },

      setReviewState: function(state) {
        this.model.reviewState = state;
      },

      setColorCategory: function(category) {
        this.model.colorCategory = category;
      },

      getColorCategory: function() {
        if (!this.model.colorCategory || HelpersService.isEmptyObject(this.model.colorCategory)) {
          this.model.colorCategory = {
            textColor: '#000000',
            backgroundColor: '#d1d1d1'
          };
        }
        return this.model.colorCategory;
      },

      createMembership: function() {
        return {
          restrictions: [],
          discounts: []
        };
      },

      setMembership: function(membership) {
        this.model.membership = membership;
      },

      getMembership: function() {
        if (!this.model.membership) {
          this.setMembership(this.createMembership());
        }
        return this.model.membership;
      },

      hasMembershipRestrictions: function() {
        return this.model.memberOnlyEvent;
      },

      checkMembershipRestrictions: function(template) {
        return template && template.memberOnlyEvent;
      },

      createEntitlementRule: function() {
        return {
          membershipLevels: {membershipLevelInfo: [], ruleApplies: 'forEachItem'},
          discountCodes: {discountCodeInfo: [], ruleApplies: 'forEachItem'},
          pricepoints: {pricepointInfo: [], ruleApplies: 'forEachItem'},
          quantity: 10000,
          timeFrame: {
            value: 1,
            period: 'day'
          }
        };
      },

      setMemberOnly: function(isMemberOnly) {
        this.model.memberOnlyEvent = !!isMemberOnly;
      },

      setEntitlement: function(entitlementConfiguration) {
        this.model.entitlementConfiguration = entitlementConfiguration;
      },

      setTicketsRules: function(ticketRuleConfig) {
        if (this.model.entitlementConfiguration) {
          this.model.entitlementConfiguration.ticketRuleConfig = ticketRuleConfig;
        }
      },

      setSalesRules: function(salesRuleConfig) {
        if (this.model.entitlementConfiguration) {
          this.model.entitlementConfiguration.salesRuleConfig = salesRuleConfig;
        }
      },

      getEntitlement: function(skipEntitlementRule) {
        if (!this.model.entitlementConfiguration) {
          this.setEntitlement({
            entitlementConfig: skipEntitlementRule ? [] : [this.createEntitlementRule()],
            salesRuleConfig: [],
            ticketRuleConfig: []
          });
        }
        return this.model.entitlementConfiguration;
      },

      createPostStartPurchase: function() {
        return {
          allowLateTicketPurchase: false,
          minutesAfter: 0
        };
      },

      getPostStartPurchase: function() {
        if (!this.model.ticketDetails.postStartPurchase) {
          this.model.ticketDetails.postStartPurchase = this.createPostStartPurchase();
        }
        return this.model.ticketDetails.postStartPurchase;
      },

      setPostStartPurchase: function(postStartPurchase) {
        this.model.ticketDetails.postStartPurchase = postStartPurchase;
      },

      createAddOns: function() {
        return {
          inventoryAddOns: [],
          inventoryIds: []
        };
      },

      hasAddOns: function() {
        return (this.model.addOns && this.model.addOns.inventoryAddOns && this.model.addOns.inventoryAddOns.length > 0);
      },

      setAddOns: function(addOns) {
        var i, ii;

        this.model.addOns = this.createAddOns();

        for (i=0,ii=addOns.length;i<ii;i++) {
          this.model.addOns.inventoryIds.push(angular.copy(addOns[i].id));
          this.model.addOns.inventoryAddOns.push(angular.copy(addOns[i]));
        }
      },

      getAddOns: function() {
        if (!this.hasAddOns()) {
          this.model.addOns = this.createAddOns();
        }
        return this.model.addOns.inventoryAddOns;
      },

      hasPriceLists: function() {
        return (this.model.priceLists instanceof Array && this.model.priceLists[0]);
      },

      getPriceList: function() {
        return (this.hasPriceLists()) ? this.model.priceLists[0] : {};
      },

      setPriceList: function(priceList) {
        // Only set the first price list since we only
        // support a single price list on B2C and POS
        this.model.priceLists = [ priceList ];
      },

      hasSchedulePriceLists: function(schedule) {
        return (schedule && schedule.priceLists instanceof Array && schedule.priceLists.length > 0);
      },

      getSchedulePriceList: function(schedule) {
        var r = false;

        if (this.hasSchedulePriceLists(schedule)) {
          r = schedule.priceLists[0];
        }else {
          r = angular.copy(this.getPriceList());
        }

        return r;
      },

      setSchedulePriceList: function(schedule, priceList) {
        schedule.priceLists = [ priceList ];
      },

      clearSchedulePriceList: function(schedule) {
        if (this.hasSchedulePriceLists(schedule)) {
          schedule.priceLists = null;
          delete schedule.priceLists;
        }
      },

      hasScheduleResourceRequests: function(schedule) {
        return (schedule && schedule.resourceRequests instanceof Array && schedule.resourceRequests.length > 0);
      },

      getScheduleResourceRequests: function(schedule) {
        var r = false;

        if (this.hasScheduleResourceRequests(schedule)) {
          r = schedule.resourceRequests;
        }else {
          r = [];
        }

        return r;
      },

      setScheduleResourceRequests: function(schedule, resourceRequests) {
        schedule.resourceRequests = resourceRequests;
      },

      clearScheduleResourceRequests: function(schedule) {
        if (this.hasScheduleResourceRequests(schedule)) {
          schedule.resourceRequests = null;
          delete schedule.resourceRequests;
        }
      },

      hasScheduleOrderForms: function(schedule) {
        return (schedule && schedule.orderForms instanceof Array && schedule.orderForms.length > 0);
      },

      getScheduleOrderForms: function(schedule) {
        var r = false;

        if (this.hasScheduleOrderForms(schedule)) {
          r = schedule.orderForms;
        }else {
          r = [];
        }

        return r;
      },

      setScheduleOrderForms: function(schedule, orderForms) {
        schedule.orderForms = orderForms;
      },

      clearScheduleOrderForms: function(schedule) {
        if (this.hasScheduleOrderForms(schedule)) {
          schedule.orderForms = null;
          delete schedule.orderForms;
        }
      },

      hasScheduleTicketConfig: function(schedule) {
        return (schedule && schedule.ticketConfig && schedule.ticketConfig.id);
      },

      getScheduleTicketConfig: function(schedule) {
        var r = false;

        if (this.hasScheduleTicketConfig(schedule)) {
          r = schedule.ticketConfig;
        }else {
          r = [];
        }

        return r;
      },

      setScheduleTicketConfig: function(schedule, ticketConfig) {
        schedule.ticketConfig = ticketConfig;
      },

      clearScheduleTicketConfig: function(schedule) {
        if (this.hasScheduleTicketConfig(schedule)) {
          schedule.ticketConfig = null;
          delete schedule.ticketConfig;
        }
      },

      setSchedule: function(schedule) {
        if (schedule && schedule.id) {
          this.model.schedules[this.getScheduleById(schedule.id).index] = schedule;
        }else if (schedule.hasOwnProperty('NEW')) {
          this.model.schedules[this.getNewSchedule().index] = schedule;
        }else{
          this.addSchedule(schedule);
        }
      },

      getSchedule: function(index) {
        var r = false;

        if (this.hasSchedules()) {
          r = this.model.schedules[index];
        }

        return r;
      },

      addSchedule: function(schedule) {
        // All new schedules are unshifted to the array with a NEW property
        schedule.NEW = true;
        if (!this.model.schedules || !(this.model.schedules instanceof Array)) {
          this.model.schedules = [];
        }
        this.model.schedules.unshift(schedule);
        return schedule;
      },

      removeSchedule: function(index) {
        if (this.hasSchedules()) {
          this.model.schedules.splice(index, 1);
        }
      },

      getNewSchedule: function() {
        var i, ii,
            r = false;

        if (this.hasSchedules()) {
          for (i=0,ii=this.model.schedules.length;i<ii;i++) {
            if (this.model.schedules[i].hasOwnProperty('NEW')) {
              r = {
                index: i,
                schedule: this.model.schedules[i]
              };
              break;
            }
          }
        }

        if (!r) {
          // New schedule is unshifted so index is 0
          r = {};
          r.index = 0;
          r.schedule = this.addSchedule(this.createSchedule());
        }

        return r;
      },

      removeNewSchedule: function() {
        this.model.schedules.splice(this.getNewSchedule().index, 1);
      },

      getScheduleById: function(id) {
        var i, ii,
            r = false;

        if (id && this.hasSchedules()) {
          for (i=0,ii=this.model.schedules.length;i<ii;i++) {
            if (this.model.schedules[i].id === id) {
              r = {
                index: i,
                schedule: this.model.schedules[i]
              };
              break;
            }
          }
        }

        return r;
      },

      setScheduleById: function(id, schedule) {
        var found = this.getScheduleById(id);
        if (found) {
          this.model.schedules[found.index] = schedule;
        }
      },

      removeScheduleById: function(id) {
        this.model.schedules.splice(this.getScheduleById(id).index, 1);
      },

      getScheduleHours: function(schedule) {
        var i, ii,
          hours = [];

        if (schedule && schedule.hours) {
          for (i = 0, ii = schedule.hours.length; i < ii; i++) {
            hours.push(this.hourToDate(schedule.hours[i]));
          }
        }else{
          hours.push(this.hourToDate(this.createHour()));
        }

        return hours;
      },

      getScheduleRangeHours: function(schedule) {
        var i, ii,
            range,
            ranges = [];

        if (schedule && schedule.ranges) {
          for (i = 0, ii = schedule.ranges.length; i < ii; i++) {
            ranges.push({
              start: this.hourToDate(schedule.ranges[i].start),
              end: this.hourToDate(schedule.ranges[i].end)
            });
          }
        }else{
          range = this.createRange();
          ranges.push({
            start: this.hourToDate(range.start),
            end: this.hourToDate(range.end)
          });
        }

        return ranges;
      },

      getPrimaryPhoto: function() {
        var i, ii;
        if (this.model.images instanceof Array) {
          for (i = 0, ii = this.model.images.length; i < ii; i++) {
            if (this.model.images[i].id === this.selectedPrimaryPhoto) {
              return this.model.images[i].screen;
            }
          }
        }
      },

      hasImages: function() {
        return (this.model.images instanceof Array);
      },

      isRepeatCycle: function(name) {
        return (this.repeatFrequency.value === name);
      },

      getRepeatType: function(type) {
        var i, ii,
          r = false;

        for (i=0,ii=this.repeatTypes.length;i<ii;i++) {
          if (this.repeatTypes[i].value === type) {
            r = this.repeatTypes[i];
            break;
          }
        }

        return r;
      },

      getRepeatMonthType: function(type) {
        var i, ii,
          r = false;

        for (i=0,ii=this.repeatMonthTypes.length;i<ii;i++) {
          if (this.repeatMonthTypes[i].value === type) {
            r = this.repeatMonthTypes[i];
            break;
          }
        }

        return r;
      },

      getScheduleRepeatCycle: function(schedule) {
        var i, ii,
            r = this.repeatTypes[0];

        if (schedule) {
          for (i = 0, ii = this.repeatTypes.length; i < ii; i++) {
            if (schedule.repeatCycle === this.repeatTypes[i].value) {
              r = this.repeatTypes[i];
              break;
            }
          }
        }

        return r;
      },

      setExpireFromEventDate: function(value) {
        this.model.ticketDetails.expireFromEventDate = value;
      },

      setPurchaseAvailability: function(timeFrame, minutes) {
        if (this.model.ticketDetails.purchaseAvailability) {
          this.model.ticketDetails.purchaseAvailability.timeFrame = timeFrame;
          this.model.ticketDetails.purchaseAvailability.minutes = minutes;
        } else {
          this.model.ticketDetails.purchaseAvailability = {
            timeFrame: timeFrame,
            minutes: minutes
          };
        }
      },

      hasValidDiscounts: function(list, property) {

        var i, ii,
            r = true,
            discountCategoryHash = {},
            discountCategoryIds = list.map( function(discount){
            if (discount[property] && discount[property].id) {
              return discount[property].id;
            }else {
              return '';
            }
          });

        for (i = 0, ii = discountCategoryIds.length; i < ii; i++) {
          if (discountCategoryIds[i]) {
            if (discountCategoryHash[discountCategoryIds[i]]) {
              r = false;
              break;
            } else {
              discountCategoryHash[discountCategoryIds[i]] = 1;
            }
          }
        }

        return r;
      },

      hasDiscounts: function(list, property) {
        var i, ii,
            r = true;
        for (i=0, ii=list.length;i < ii ; i++) {
          if (!(list[i][property]) || !(list[i][property].id)) {
            r = false;
            break;
          }
        }
        return r;
      },

      hasMembershipDiscount: function(list, property) {
        var i, ii,
          r = true;
        for (i=0, ii=list.length;i < ii ; i++) {
          if (!(list[i][property]) || !(list[i][property].length)) {
            list[i]._errors = [true].concat(list[i]._errors);
            r = false;
          }
        }
        return r;
      },

      verifyCustomFields: function() {
        var i, ii;

        // Splice out custom fields with no values to prevent errors
        if (this.model.customFields instanceof Array) {
          for (i=this.model.customFields.length - 1,ii=0;i>=ii;i--) {
            if (
              this.model.customFields[i].value &&
              this.model.customFields[i].name.replace(/s+/g).length > 0 &&
              this.model.customFields[i].value.replace(/s+/g).length > 0
            ) {
              // Valid do nothing
            }else{
              // Splice out the fields
              this.model.customFields.splice(i, 1);
            }
          }
        }
      },

      verifySchedules: function() {
        var i, ii;

        if (this.hasSchedules()) {

          // Migrate start dates to all schedules
          for (i=0,ii=this.model.schedules.length;i<ii;i++) {
            // Copy temporary weekday values
            if (this.model.schedules[i].repeatCycle === 'month') {
              if (this.model.schedules[i].daysOfMonth instanceof Array &&
                  this.model.schedules[i].daysOfMonth.length > 0) {
                this.model.schedules[i].monthly = null;
                delete this.model.schedules[i].monthly;

                this.model.schedules[i].weekdays = null;
                delete this.model.schedules[i].weekdays;

              } else if (this.model.schedules[i].monthly instanceof Array &&
                         this.model.schedules[i].monthly.length > 0) {
                this.model.schedules[i].daysOfMonth = null;
                delete this.model.schedules[i].daysOfMonth;
              }
            } else {
              this.model.schedules[i].monthly = null;
              delete this.model.schedules[i].monthly;

              this.model.schedules[i].daysOfMonth = null;
              delete this.model.schedules[i].daysOfMonth;

              // Include a days object if event never repeats
              if (this.model.schedules[i].repeatCycle === 'never') {
                this.model.schedules[i].days = [CalendarService.toYMDDate(CalendarService.parseDate(this.model.schedules[i].effectiveStartTime))];
              }else{
                this.model.schedules[i].days = null;
                delete this.model.schedules[i].days;
              }
            }
          }

          this.verifyScheduleRanges();
        }
      },

      verifyScheduleRanges: function() {
        var i, ii;
        // if General Admission, make sure the schedule has a ranges property or create one.
        if (this.isAdmissionType('generalAdmission')) {
          for (i=0,ii=this.model.schedules.length;i<ii;i++) {
            if (!this.model.schedules[i].ranges) {
              this.model.schedules[i].ranges = [];
              this.model.schedules[i].ranges.push(this.createRange());
            }
          }
        }
      }

    };

}]);